module.exports = __webpack_public_path__ + "img/shiLin3.0f69a012.png";